import { render } from "./ProjectTab.vue?vue&type=template&id=1bf6923c"
import script from "./ProjectTab.vue?vue&type=script&lang=js"
export * from "./ProjectTab.vue?vue&type=script&lang=js"

import "./ProjectTab.vue?vue&type=style&index=0&id=1bf6923c&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__